

import BaseService from './BaseService';

export interface InfoProps {
  store_id: number | string;
}

export interface ProductsProps {
  store_id: number;
  order_type: number;
}

export interface TablesProps {
  store_id: number;
  tables: boolean;
  table_categories?: any;
}

export interface FeaturedProductsProps {
  store_id: number;
  order_type: number;
}

export interface BannersProps {
  store_id: number;
  order_type: number;
}

export interface ListPaymentMethodsProps {
  store_id: number;
  order_type: number;
}

export interface DistanceProps {
  store_id: number;
  latitude: number;
  longitude: number;
  success?: boolean;
  message?: string;
}

export interface StoreListProps {
  state?: string;
  latitude?: number;
  longitude?: number;
}

// export interface PIXPROPS {
//   payment_method_id: number;
//   payment_method: number;
//   store_id: number;
//   orderType: number;
//   cashier_id: number;
//   store_cashiers?: any;
// }
export interface CashiersProps {
  store_id: number;
  user: boolean;
  sort: string;
  date_from: string;
  date_to: string;
  store_cashiers?: any;
}

export default class StoreService {
  baseService: BaseService;
  ApiBaseService: BaseService;
  constructor(orderType: string) {
    this.baseService = new BaseService(orderType);
    this.ApiBaseService = new BaseService('');
  }

  async info (params: InfoProps): Promise<InfoProps> {
    try {
      const store_id = params.store_id

      const response = await this.ApiBaseService.http.get<InfoProps>(`stores/${store_id}/info`);
      return response.data;
    } catch (error) {
      console.error('Erro info:', error);
      throw error;
    }
  }

  async products (params: ProductsProps): Promise<any> {
    try {
      const store_id = params.store_id
      const order_type = params.order_type

      const response = await this.baseService.http.get<ProductsProps>(`stores/products?store_id=${store_id}&order_type=${order_type}`);
      return response.data;
    } catch (error) {
      console.error('Erro products:', error);
      throw error;
    }
  }

  async tables (params: TablesProps): Promise<TablesProps> {
    try {
      const payload = { store_id: params.store_id, tables: params.tables };
      const response = await this.baseService.http.post<TablesProps>('tables/list', payload);
      return response.data.table_categories;
    } catch (error) {
      console.error('Erro products:', error);
      throw error;
    }
  }

  async featuredProducts (params: FeaturedProductsProps): Promise<FeaturedProductsProps> {
    try {
      const response = await this.baseService.http.get<FeaturedProductsProps>(`stores/featureds?store_id=${params.store_id}&order_type=${params.order_type}`);
      return response.data;
    } catch (error) {
      console.error('Erro featured products:', error);
      throw error;
    }
  }

  async listPaymentMethods (params: ListPaymentMethodsProps): Promise<ListPaymentMethodsProps> {
    try {
      const response = await this.ApiBaseService.http.get<ListPaymentMethodsProps>(`stores/${params.store_id}/payment/list?order_type=${params.order_type}`);
      return response.data;
    } catch (error) {
      console.error('Erro listPayment:', error);
      throw error;
    }
  }

  async cashiers (payload: CashiersProps): Promise<CashiersProps> {
    try {
      const response = await this.baseService.http.post<CashiersProps>('cashiers/list', payload);
      return response.data.store_cashiers;
    } catch (error) {
      console.error('Erro cachiers:', error);
      throw error;
    }
  }

  async distance (params: DistanceProps): Promise<DistanceProps> {
    try {
      const response = await this.baseService.http.get<DistanceProps>(`stores/${params.store_id}/distance?lat=${params.latitude}&lng=${params.longitude}`);
      return response.data;
    } catch (error) {
      console.error('Erro distance:', error);
      throw error;
    }
  }

  async stores (params: StoreListProps): Promise<any> {
    try {
      var state = '';
      if (params.state) {
        state = `&state=${params.state}`;
      }
      var longLat = '';
      if (params.latitude && params.longitude) {
        longLat = `&lat=${params.latitude}&lng=${params.longitude}`;
      }
      const response = await this.baseService.http.get<StoreListProps>(`stores/list?${state}${longLat}`);
      return response.data;
    } catch (error) {
      console.error('Erro stores:', error);
      throw error;
    }
  }

  async states(): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get('stores/list/states');
      return response.data;
    } catch (error) {
      console.error('Erro stores:', error);
      throw error;
    }
  }

  async hasStoresInCity(city: string): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get(`stores/has-stores-in-city?city=${city}`);
      return response.data;
    } catch (error) {
      console.error('Erro hasStoresInCity:', error);
      throw error;
    }
  }

  async banners(params: BannersProps): Promise<BannersProps> {
    try {
      const response = await this.ApiBaseService.http.get<BannersProps>(`banners?store_id=${params.store_id}&order_type=${params.order_type}`);
      return response.data;
    } catch (error) {
      console.error('Erro banners:', error);
      throw error;
    }
  }

}